import { PERSONA_OPTIONS, PersonaId } from "./personaOptions";
import { LogInPrompt } from "./LogInPrompt";

// ACA-266 builds the picker (AC1) and ACA-267/268/269 reuse it: same four cards, same copy, same
// behaviour, whichever flow follows. Choosing a card moves on immediately — there is no Continue
// here, which is what the sub-heading promises and what the design does.

export interface PersonaPickerProps {
  /** The card already chosen, when the flow comes back to this step. */
  selected?: PersonaId;
  onSelect: (persona: PersonaId) => void;
}

export function PersonaPicker({ selected, onSelect }: PersonaPickerProps) {
  return (
    <div className="persona-picker">
      <h1 className="onboarding-v2__heading" data-testid="screen-heading">
        Welcome to Artlogic Connect. Tell us about yourself.
      </h1>
      <p className="onboarding-v2__lead" data-testid="screen-subheading">
        Pick the one that fits best — we&apos;ll take you straight on.
      </p>

      <div className="persona-picker__grid">
        {PERSONA_OPTIONS.map((option) => {
          const isSelected = option.id === selected;

          return (
            <button
              key={option.id}
              type="button"
              className="persona-picker__card"
              data-selected={isSelected ? "true" : "false"}
              aria-current={isSelected ? "true" : undefined}
              data-testid={`persona-card-${option.id}`}
              onClick={() => onSelect(option.id)}
            >
              {/* The photograph is decoration: the card's name and blurb are right beneath it, and
                  an alt of "Gallery" would only make a screen reader say it twice. */}
              <span className="persona-picker__media">
                <img src={option.image} alt="" loading="lazy" />
              </span>
              <span className="persona-picker__body">
                <span className="persona-picker__label">{option.label}</span>
                <span className="persona-picker__blurb">{option.blurb}</span>
              </span>
            </button>
          );
        })}
      </div>

      <LogInPrompt />
    </div>
  );
}
